module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('table', [_c('tbody', _vm._l((_vm.footnotes), function(footnote) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(footnote))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.note[footnote])
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1f2d2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/Footnotes.vue
// module id = 125
// module chunks = 0